<template>
    <div>

        <!-- Table -->

        <!-- No state: this widget belongs to a phase dashboard, where a list is read in the
             context of the page and never picked up again where it was left. -->

        <trax-ui-ajax-data-table v-if="atpDafPermission"
            :id="id" :props="props" :endpoint="endpoint" :endpoint-params="endpointParams"
            header="0" searching="0" lengthChange="0" :save-state="false">
        </trax-ui-ajax-data-table>

        <!-- Creation button -->

        <div class="text-center mt-3" v-if="atpDafPermission && atpDafCreationPermission && atpDafCreationStatus">
            <button class="btn btn-round btn-primary" data-toggle="modal" :data-target="'#'+id+'-edit'">
                {{ buttonLabel }}
            </button>
        </div>

        <!-- Editing modal -->

        <trax-ui-modal-default :id="id+'-edit'" :bus="bus" :title="buttonLabel">
            <enac-procedure-atp-daf-edit-popup :bus="bus"></enac-procedure-atp-daf-edit-popup>
        </trax-ui-modal-default>

    </div>
</template>

<script>
    export default {
    
        props: {
            id: { default: 'enac-procedure-daf-widget' }
        },

        data: function() {
            return {
                lang: lang,
                user: user,
                registration: data.registration,
                phase: data.phase,
                learner: data.learner,
                endpoint: app_url+"polaris/api/front/procedures",
                endpointParams: {
                    relations: ['user', 'users'],
                    filters: {
                        registration_id: data.registration.id,
                        phase_id: data.phase.id,
                        ...(data.learner && { learner_id:  data.learner.id }),
                    },
                    sort: ['-date']
                },
                editUrl: app_url+"polaris/ui/atpl-dashboard/registration/"+data.registration.id+"/procedure/atp-daf/edit",
                props: [
                    {source: this.description, orderable: false, class: 'font-weight-bold' },
                    {source: this.status, orderable: false, class: 'text-center trax-width-120' },
                ],
                bus: new Vue()
            }
        },

        computed: {

            buttonLabel: function() {
                return this.learner ? this.lang.polaris.procedure.new_atp : this.lang.polaris.procedure.new_daf;
            },

            atpDafCreationPermission: function() {
                return this.user.admin 
                    || (this.learner && this.user.permissions['procedure.write-atp'])
                    || (!this.learner && this.user.permissions['procedure.write-daf']);
            },

            atpDafCreationStatus: function() {
                return this.registration.status != 'draft' && this.registration.status != 'archived';
            },

            atpDafPermission: function() {
                return this.user.admin || this.user.permissions['procedure.read-atp'] || this.user.permissions['procedure.read-daf'] 
                    || this.user.permissions['procedure.write-atp'] || this.user.permissions['procedure.write-daf'];
            }
        },

        created: function() {
            this.bus.$on(this.id+'-edit-created', this.created);
        },
        
        methods: {
        
            created(request) {
                window.location = this.editUrl + '/' + request.response.data.data.id;
            },

            // Columns rendering

            description(data, type, row, meta) {
                var type = row.user ? 'ATP' : 'DAF'
                var html = '<b>' + type + ': </b>' + row.name;
                if (row.user) html += '<br><small>'+row.user.lastname+' '+row.user.firstname+'</small>';
                if (row.users && row.users.length) html += '<br><small>'+row.users.length+' '+this.lang.polaris.procedure.learners_lc+'</small>';
                return this.link(row, html);
            },

            status(data, type, row, meta) {

                // Status
                var label = row.status;
                var color = 'info';
                if (row.status == 'posted') color = 'warning';
                else if (row.status == 'submitted') color = 'danger';
                else if (row.status == 'validated') color = 'success';
                else if (row.status == 'closed') color = 'default';
                var html = '<span class="badge badge-'+color+'">'+label+'</span>';

                // Date
                var timestamp = moment(row.date);
                timestamp = timestamp.format('DD MMM YYYY');
                html += '<br><small>'+timestamp+'</small>';

                return this.link(row, html);
            },

            link(procedure, content) {
                var href = this.editUrl + '/' + procedure.id;
                return '<a href="'+href+'">'+content+'</a>';
            }

        }

    }
</script>
